export default function KtTooltipEnableOnEllipsis() {
    return {
        restrict: 'A',
        controller: KtTooltipEnableOnEllipsisController,
        controllerAs: 'KtTooltipEnableOnEllipsisCtrl',
        compile: ktTooltipEnableOnEllipsisCompile,
    };
}

export function KtTooltipEnableOnEllipsisController($element, $attrs) {
    'ngInject';

    const vm = this;
    const textElem = $attrs.calculateParent
        ? $element[0].parentElement
        : $element[0];

    vm.isOverflow = () => {
        return textElem.scrollWidth > textElem.offsetWidth;
    };
}

export function ktTooltipEnableOnEllipsisCompile(element, attrs) {
    attrs.$set('tooltipEnable', 'KtTooltipEnableOnEllipsisCtrl.isOverflow()');
}



// WEBPACK FOOTER //
// ./src/app/modules/common/typeahead-dropdown/ktTooltipEnableOnEllipsis.directive.js